module.exports = {
  Config: {
    Language: '繁體中文'
  },
  Interface: {
    Title: '怪物獵人世界裝備編輯器',
    Download: '下載離綫版',
    DownloadVersion: '選擇下載版本',
    Installed: '安裝版',
    FreeInstallation: '免安裝版',
    Portable: '便携版',
    Lang: '語言Language',
    Menu: '選單',
    New_file: '新建',
    Open_file: '打開',
    Open_Success: '檔案已打開',
    Open_Failure: '檔案打開失敗',
    Save_file: '保存',
    Save_Success: '保存成功',
    Save_Failure: '保存失敗',
    Insert: '插入',
    InsertHex: '插入内容',
    InsertAddress: '插入地址(16進制)',
    Insert_Success: '插入完成',
    About: '關於',
    Setting: '設定',
    Elimination_unknown_weapons: '排除未知武器',
    Raw_data_comparison: '原始資料對比',
    Binary_mode: '二進位模式',
    Dark_theme: '暗黑主題',
    Data_version: '數據版本',
    Original_file_version: '原始檔案版本',
    Extract_from: '選取自',
    Current_file: '當前檔案',
    AddConfig: '加載數據範本',
    Read: '已讀',
    Refuse: '拒絕',
    Cancel: '取消',
    Continue: '繼續',
    Loading: '加載中,請稍等',
    Loading_Environment: '正在加載環境，請稍後',
    Loading_Environment_info: '如果長時間無法完成加載，可點擊下方已讀按鈕繼續使用，未完成加載部分功能無法正常使用',
    Instructions: '使用說明',
    No_file_opened: '未打開文件',
    No_data: '無可用數據',
    Original: '原始',
    Old_version: '相容模式',
    Version_update: '版本更新',
    Update_description: '更新說明',
    Old_version_save: '請勿保存兼容模式',
    Weapon: '武器',
    equipment: '裝備',
    Weaponsmiscellaneous: '武器雜項',
    Oldfile: '可能是舊版本文件',
    Tools: '開發者工具箱',
    Tools_data: '資料數據',
    Tools_dataMerge: 'Mod合并',
    Tools_dataConfig: '生成Mod變更文件',
    Tools_encryption: '加解密工具',
    Tools_Hex: '二進制編輯',
    Tools_View: '視圖編輯',
    Tools_insert: '插入數據',
    Tools_Help: '教程',
    Unopen: '暫未開放',
    Request: '申請',
    Warning: '警告',
    EncryptionFile: '選擇待加密文件',
    DencryptionFile: '選擇待解密文件',
    DownloadDencryption: '下載加解密工具',
    VCLow_version: 'VC++版本較低，可能無法正常運行Mod，建議升級后使用',
    NewInterface: '體驗新界面',
    Other: '其他',
    TranslationProvider: ''//Fill in the name of the translation provider here, for example (翻譯：Alcedo).
  },
  Explanatory: {
    Elimination_unknown_weapons: '武器信息清單中排除掉未被記載的武器數據',
    Raw_data_comparison: '與系統中記載的原始武器資訊進行對比',
    Binary_mode: '顯示檔案二進位數據的檔案模式,二進位數據根據武器類型進行輔助顯示',
    Dark_theme: '切換軟件主色調至暗黑模式',
    About_content: '本軟件可針對《怪物獵人世界》中武器數據魔改檔案進行查看和修改,修改後檔案放置在Monster Hunter World\\nativePC\\common\\equip\\下即可生效。修改後檔案將影響遊戲平衡性,請勿用於聯機使用。',
    About_edition: '軟體版本：1.3.2',
    Instructions: '<h3>該工具可以讀取解包後的武器數據,內寘了當前版本的武器資料檔案,可以直接新建mod檔案。部分數值修改會根據固有係數自動修正,武器資訊為手動錄入,可能與現版本數據存在差异。修改後的檔案請勿用於聯機使用。</h3><br><h4>用法：</h4><br><span>&nbsp;&nbsp;1、打開解包後的mod檔案或點擊新建選擇需要的武器檔案</span><br><span>&nbsp;&nbsp;2、蒐索或手動找到要修改的武器</span><br><span>&nbsp;&nbsp;3、將相應内容改成你希望的數值</span><br><span>&nbsp;&nbsp;4、點擊保存將檔案保存至遊戲目錄\\nativePC\\common\\equip\\</span><br><span>&nbsp;&nbsp;5、安裝冰原裝載Mod（https://www.nexusmods.com/monsterhunterworld/mods/1984）</span><br><br><h4>工具原始程式碼發佈在Github上：https://github.com/HalcyonAlcedo/MHW-Weaponeditor</h4>',
    Old_version: '將以名稱匹配方式打開資料檔案,建議使用新版本資料檔案進行魔改。',
    Old_version_open: '相容模式已啟動,請重新打開資料檔案',
    Old_version_close: '相容模式已關閉,請重新打開資料檔案',
    Version_update: '將現時打開的檔案更新到新版本',
    Version_update_true: '版本數據更新完成,請勿忘記保存資料檔案',
    Free_model: '如需修改模型請調整為修改數據，不懂勿動',
    Have_model: '如需關閉模型請改成65535',
    Update_description: '<ul><li>優化Fsm數據插入功能</li><li>修復异常數據</li></ul>',
    Toolsinfo: '開發者工具箱只針對MOD開發人員開放，工具箱内包含本工具内置的數據信息和一些實用工具，如需申請開發者認證許可，請在下方填寫您曾經發佈過的一個Mod地址並提交申請，審核通過后在有效期内可隨意使用，點擊已讀可臨時試用該功能。',
    NewInterface: '嘗試新的編輯界面',
    ResetChopping: '需要開啓原始數據對比功能',
    NoLimit: '當前無修改限制',
    DidNotOpen: '當前文件未開啓新版編輯界面功能，請使用舊版界面操作',
    Encryptionwarning: '當前要修改的文件為加密文件,請使用加解密工具解密后再次打開解密后的文件',
    Dencryptionwarning: '當前要修改的文件為解密后的文件，保存后請使用加解密工具加密后放入游戲才能生效',
    EncryptionHelp: `
    此工具用於解密被加密的數據文件和將解密的文件加密回程序識別的加密文件</br>
    當前内置了 cus_pa、cus_par、msk、owp_dat、dtt_eda、dtt_epg、plp、plsp、plip、asp、shlp 類型的文件密鑰，如果你有其他類型的加密文件和密鑰可以在Github上告訴我，確認后會補充進系統
    `,
    ConfigAuthor: '當前配置文件作者：',
    SizeCheck: '當前檔案數據量過大，不建議使用二進位編輯模式',
    SizeCheckMax: '當前檔案數據量過大，無法使用二進位模式編輯',
    InsertDataWarning: '數據插入可能會對數據造成不可逆損毀，建議確認插入時檢查插入數據和地址是否正確，保存檔案之前對檔案先行備份。',
    InsertToAddress: '指定地址插入數據',
    InsertToFSM: 'FSM派生數據插入',
    InsertToLMT: 'LMT動作數據插入',
    FSMInsertInfo: '先定位招式地址，然後生成派生數據範本，最後插入派生數據。 派生id和條件id可參攷fsm設定檔獲取到的數據，描述和招式名可能會有出入，以招式id為准。'
  },
  Weaponsmiscellaneous: {
    Sharpness: '斬味',
    Wswordattribute: '雙屬性',
    Saxebottle: '斬瓶',
    Bombardment: '銃槍炮擊',
    Syllable: '笛音',
    Rod: '獵蟲',
    Skill: '技能',
    Bottle: '弓瓶',
    Shell: '弩彈',
    ASkill: '装置',
    WeaponDerived: '武器派生',
    WeaponMake: '武器制造'
  },
  Armor: {
    Armor: '裝備',
    ArmorMake: '裝備製造'
  },
  Weaponrecipe: {
    Number: '武器Id',
    Type: '武器类型',
    wus_wz: '未知',
    item1: '素材1',
    item1quantity: '素材1數量',
    item2: '素材1',
    item2quantity: '素材2數量',
    item3: '素材3',
    item3quantity: '素材3數量',
    item4: '素材4',
    item4quantity: '素材4數量',
    Unlock: '解鎖條件',
  },
  Armorrecipe: {
    Number: '裝備Id',
    Type: '裝備类型',
    item1: '素材1',
    item1quantity: '素材1數量',
    item2: '素材1',
    item2quantity: '素材2數量',
    item3: '素材3',
    item3quantity: '素材3數量',
    item4: '素材4',
    item4quantity: '素材4數量',
    Unlock: '解鎖條件',
  },
  Sharpness: {
    Number: '斬味id',
    Weaponlist: '影響武器列表',
    Red: '紅斬',
    Orange: '橙斬',
    Yellow: '黃斬',
    green: '綠斬',
    blue: '藍斬',
    white: '白斬',
    purple: '紫斬'
  },
  Wswordattribute: {
    Number: '雙刀雙屬性id',
    First_attribute: '第一屬性',
    First_attribute_values: '第一屬性值',
    Second_attribute: '第二屬性',
    Second_attribute_values: '第二屬性值'
  },
  Saxebottle: {
    Number: '斬瓶id',
    Bottle_type: '斬瓶類型',
    Attribute_values: '屬性值'
  },
  Huntingbottle: {
    Number: '弓瓶id',
    Bottle_type_1: '接擊瓶',
    Bottle_type_2: '强擊瓶',
    Bottle_type_3: '麻瓶',
    Bottle_type_4: '毒瓶',
    Bottle_type_5: '眠瓶',
    Bottle_type_6: '爆瓶'
  },
  Shell: {
    Number: '彈種id',
    Normal_1: '通常彈LV1',
    Normal_2: '通常彈LV2',
    Normal_3: '通常彈LV3',
    Through_1: '貫通彈LV1',
    Through_2: '貫通彈LV2',
    Through_3: '貫通彈LV3',
    Scattering_1: '散彈LV1',
    Scattering_2: '散彈LV2',
    Scattering_3: '散彈LV3',
    Diffusion_1: '擴散彈LV1',
    Diffusion_2: '擴散彈LV2',
    Diffusion_3: '擴散彈LV3',
    Dragon_shot: '龍擊彈',
    Slash: '斬裂彈',
    Grenade_1: '撤甲榴彈LV1',
    Grenade_2: '撤甲榴彈LV2',
    Grenade_3: '撤甲榴彈LV3',
    Fire: '火彈',
    Water: '水彈',
    Ice: '冰彈',
    Electricity: '电彈',
    Dragon: '龍彈',
    Poison_1: '毒彈LV1',
    Poison_2: '毒彈LV2',
    Hemp_1: '麻彈LV1',
    Hemp_2: '麻彈LV2',
    Sleep_1: '眠彈LV1',
    Sleep_2: '眠彈LV2',
    Reduce_breath: '灭气彈',
    Restores_1: '回復彈LV1',
    Restores_2: '回復彈LV2',
    Madman: '鬼人彈',
    Harden: '硬化彈',
    Capture: '捕獲彈',
    Ammunition: '彈藥数',
    Model: '射擊模式',
    Recoil: '反動',
    Speed: '上彈速度'
  },
  Bombardment: {
    Number: '銃槍炮擊id',
    Bombard_type: '炮擊類型',
    Bombard_level: '炮擊等級'
  },
  Syllable: {
    Number: '笛音id',
    Syllable1: '音色1',
    Syllable2: '音色2',
    Syllable3: '音色3'
  },
  ASkill: {
    Number: '装置id',
    Type: '装置类型',
    Slot_grade_Number: '鑲孔數量',
    Slot_grade_Number1: '1孔等級',
    Slot_grade_Number2: '2孔等級',
  },
  Equipment: {
    Number: '裝備id',
    Type: '裝備類型',
    Equipment_model: '幻化ID',
    Variant: '特型',
    Patience1: '火耐性',
    Patience2: '水耐性',
    Patience3: '冰耐性',
    Patience4: '雷耐性',
    Patience5: '龍耐性',
    skill1: '技能一',
    skill2: '技能二',
    skill3: '技能三',
    skill4: '技能四',
    skill5: '技能五',
    skilllv1: '技能一等級',
    skilllv2: '技能二等級',
    skilllv3: '技能三等級',
    skilllv4: '技能四等級',
    skilllv5: '技能五等級'
  },
  Insect: {
    Number: '獵蟲id',
    Craft_costs: '購買費用',
    Type: '攻擊系統',
    Speed: '速度',
    Power: '力量',
    Heal: '回復',
    Rarity: '治愈',
    Dust: '粉尘',
    DustEffect_0: '爆破',
    DustEffect_1: '回復',
    DustEffect_2: '麻痹',
    DustEffect_3: '毒',
    Unknown: '未知'
  },
  Weapon: {
    Charge_blade: '盾斧',
    Gunlance: '銃槍',
    Hammer: '大錘',
    Greatsword: '大劍',
    Lance: '長槍',
    Insect_glaive: '蟲棍',
    Switch_axe: '斬斧',
    Blade: '片手',
    Longsword: '太刀',
    Dual_blade: '雙刀',
    Hunting_horn: '獵笛',
    Light_crossbow: '輕弩',
    Heavy_crossbow: '重弩',
    Hunting_bow: '弓',
    Unknown: '未知'
  },
  WeaponExplain: {
    Describe: '描述',
    Address: '地址',
    Edit_data: '修改數據',
    Sequence_number: '武器序號',
    Independent_model: '獨立模型',
    Weapon_model: '武器模型',
    Weapon_secondary_model: '次要模型',
    Manufacturing_costs: '製造費用',
    Production_expenses: '稀有度',
    Chopping_value: '斬味匹配',
    Chopping_grade: '斬味',
    Chopping_grade_quick1: '短白',
    Chopping_grade_quick2: '中白',
    Chopping_grade_quick3: '長白',
    Reset: '重置',
    Damage: '傷害值',
    Defense: '防禦值',
    Heart: '會心值',
    Visible_attributes: '可見内容',
    Visible_attribute_values: '可見内容數值',
    Hidden_attributes: '隱藏屬性',
    Hidden_attribute_values: '隱藏屬性數值',
    Match_projectile: '彈種匹配',
    Ballistic_offset: '偏移',
    Seal_Dragon: '封龍力',
    Slot_grade_Number: '鑲孔數量',
    Slot_grade_Number1: '1孔等級',
    Slot_grade_Number2: '2孔等級',
    Slot_grade_Number3: '3孔等級',
    clothes: '衣装',
    pipe: '烟筒',
    Special_attributes: '特殊内容',
    Weapon_skills: '武器技能',
    Unknown: '未知',
    Nothing: '無',
    Verybig: '特大',
    Big: '大',
    Inside: '中',
    Small: '小',
    NoGroove: '無孔槽',
    OneGroove: '一個孔槽',
    TwoGroove: '二個孔槽',
    ThreeGroove: '三個孔槽',
    OneGroovel: '一級孔槽',
    TwoGroovel: '二級孔槽',
    ThreeGroovel: '三級孔槽',
    FourGroovel: '四級孔槽',
    Specialprojectile: '特殊彈種',
    Setbomb: '起爆龍彈',
    Gatling: '機關龍彈',
    Snipe: '狙擊龍彈',
    Error: '錯誤',
    Fire: '火',
    Water: '水',
    Ice: '冰',
    Electricity: '電',
    Dragon: '龍',
    Poison: '毒',
    Hemp: '麻',
    Sleep: '眠',
    Burst: '爆',
    Cut: '切斷',
    Strike: '打擊',
    Attribute: '内容',
    Speed: '速度',
    Power: '力量',
    Endurance: '耐力',
    Restores: '回復',
    Extinguish_dragon: '滅龍',
    Reduce_breath: '减氣',
    Strong_exocet_bottle: '榴彈瓶',
    Strong_attribute_bottle: '強屬性瓶',
    Normal_type: '通常型',
    Diffusion_type: '擴散型',
    Radiological_type: '放射型',
    Rapid_type: '速射型',
    Automatic_type: '自动装填',
    Dragon_type: '龍擊蓄力',
    Fast: '快',
    Medium: '中',
    Slightly_slow: '稍慢',
    Slow: '慢',
    Purple_timbre: '紫音',
    Red_timbre: '红音',
    Orange_timbre: '橙音',
    Yellow_timbre: '黄音',
    Green_timbre: '绿音',
    Blue_timbre: '蓝音',
    Indigo_timbre: '青音',
    White_timbre: '白音',
    Equipment_type_0: '头盔',
    Equipment_type_1: '胸甲',
    Equipment_type_2: '手套',
    Equipment_type_3: '腰带',
    Equipment_type_4: '护腿',
    Equipment_type_5: '护石',
    Equipment_variant_1: 'α、γ',
    Equipment_variant_2: 'β',
    Ordinary: '普通',
    Intensify: '强化'
  },
  Skill: {
    Number: '技能id',
    Level: '技能等級',
    Parameter_1: '參數1',
    Parameter_2: '參數2',
    0: '無技能',
    1: '毒耐性',
    2: '麻痹耐性',
    3: '睡眠耐性',
    4: '昏厥耐性',
    5: '泥耐性',
    6: '爆破异常狀態的耐性',
    7: '裂傷耐性',
    8: '防禦力下降耐性',
    9: '樣本',
    11: '耳塞',
    12: '風壓耐性',
    13: '耐震',
    14: '异臭名人',
    16: '適應瘴氣環境',
    17: '熱傷害無效',
    19: '攻擊',
    20: '防禦',
    21: '體力增强',
    22: '體力回復量上升',
    23: '回復速度',
    24: '火耐性',
    25: '水耐性',
    26: '冰耐性',
    27: '雷耐性',
    28: '龍耐性',
    29: '内容异常狀態的耐性',
    30: '火内容攻擊强化',
    31: '水内容攻擊强化',
    32: '冰内容攻擊强化',
    33: '雷内容攻擊强化',
    34: '龍内容攻擊强化',
    35: '毒内容强化',
    36: '麻痹内容强化',
    37: '睡眠内容强化',
    38: '爆破内容强化',
    39: '通常彈‧通常箭强化',
    40: '貫通彈‧龍之箭强化',
    41: '散彈‧剛射强化',
    42: '毒瓶追加',
    43: '麻痹瓶追加',
    44: '睡眠瓶追加',
    46: '爆破瓶追加',
    47: '内容解放／裝填擴充',
    48: '看破',
    49: '超會心',
    50: '弱點特效',
    51: '樣本',
    52: '集中',
    53: '强化持續',
    54: '匠',
    55: '拔刀術【技】',
    56: '破壞王',
    57: '擊暈術',
    58: '奪取耐力',
    59: '騎乘名人',
    60: '飛燕',
    61: '力之解放',
    62: '挑戰者',
    63: '無傷',
    64: '火場怪力',
    65: '不屈',
    66: '怨恨',
    67: '死裡逃生',
    68: '吹笛名人',
    69: '炮彈裝填數提升',
    70: '特殊射擊强化',
    71: '炮術',
    72: '炮擊手',
    73: '跑者',
    74: '體術',
    75: '飛身躍入',
    76: '耐力急速回復',
    77: '饑餓耐性',
    78: '回避效能',
    79: '回避距離提升',
    80: '防禦效能',
    81: '納刀術',
    82: '廣域化',
    83: '道具使用强化',
    84: '滿足感',
    85: '快吃',
    86: '砥石使用高速化',
    88: '炸彈客',
    90: '最愛蘑菇',
    91: '釣魚名人',
    92: '烤肉名人',
    93: '搬運達人',
    94: '採集達人',
    95: '蜂蜜獵人',
    96: '剝取鐵人',
    97: '精靈加護',
    98: '訓示隨從',
    99: '植生學',
    100: '地質學',
    101: '精神抖擻',
    102: '投射器裝填數提升',
    103: '潜伏',
    104: '減輕膽怯',
    105: '導蟲反應距離提升',
    106: '蹲下移動速度提升',
    107: '跳躍鐵人',
    108: '棉花孢子草的知識',
    109: '適應水場',
    111: '攀岩者',
    112: '閃光强化',
    114: '研究者',
    115: '昆蟲標本達人',
    116: '瘴氣耐性',
    117: '追跡達人',
    118: '探索者的幸運',
    119: '察覺',
    120: '整備',
    122: '滑走强化',
    123: '龍封力强化',
    124: '威嚇',
    125: '蠻顎龍之力',
    126: '滅盡龍之饑餓',
    127: '屍套龍之命脈',
    128: '火龍之力',
    129: '角龍之力',
    130: '幻獸之恩惠',
    131: '櫻火龍之奧秘',
    132: '蠻顎龍之鬥志',
    135: '火龍奧秘',
    136: '角龍之奧秘',
    137: '幻獸之恩寵',
    138: '爆錘龍之守護',
    142: '爆鱗龍之守護',
    143: '炎王龍之武技',
    144: '鋼龍的飛翔',
    145: '冥燈龍的神秘',
    147: '熔山龍的奧秘',
    149: '公會的指引',
    150: '調查團的指引',
    151: '風漂龍的恩惠',
    152: '風漂龍的恩寵',
    153: '慘爪龍之力',
    154: '慘爪龍的奧秘',
    155: '解放弓的蓄力階段',
    156: '心眼／彈道强化',
    157: '防禦强化',
    158: '剛刃研磨',
    159: '無内容强化',
    160: '毅力',
    161: '加速再生',
    162: '利刃／彈丸節約',
    163: '炎妃龍的恩寵',
    164: '龍騎士之證',
    165: '會心攻擊【屬性】',
    166: '會心攻擊【特殊】',
    167: '狩魔獵人的心得',
    168: '星辰的祝福',
    169: '雷狼龍的真髓',
    170: '轟龍的真髓',
    171: '迅龍的真髓',
    172: '碎龍的真髓',
    173: '斬龍的真髓',
    174: '銀火龍的真髓',
    175: '金火龍的真髓',
    176: '天地煌啼龍的神秘',
    177: '溟波龍的神秘',
    178: '冰呪龍的神秘',
    179: '太古的神秘',
    180: '調查團的鍊金術',
    181: '教官的引導',
    182: '蠻顎龍的霸氣',
    183: '雌火龍的真髓',
    184: '佯動攻擊',
    185: '攻擊守勢',
    186: '轉禍為福',
    187: '受身術',
    188: '冰牙龍的秘技',
    189: '火龍的真髓',
    190: '角龍的霸氣',
    191: '風漂龍的霸氣',
    192: '慘爪龍的真髓',
    193: '爆鎚龍的霸氣',
    194: '爆鱗龍的霸氣',
    195: '恐暴龍的真髓',
    196: '屍套龍的靈脈',
    199: '幻獸的神秘',
    200: '公會的見識',
    201: '熔山龍的真髓',
    202: '炎妃龍的真髓',
    203: '滅盡龍的霸氣',
    205: '鈍器能手',
    206: '振奮',
    207: '寒冷耐性',
    208: '金獅子的怒氣',
    210: '生還者',
    212: '萬福的祝福',
    213: '大感謝的祝福',
  }
}
